import type { UUID } from '@protector/utils/types';
import type { UpsertStationSuccessCallbacks } from 'entities/stations/stations.models';
import { StaticPointFieldEnum } from '@protector/entities/static-point/constants';
import type { StaticPointType } from '@protector/entities/static-point/constants';
import type { StaticPoint, StaticPointCreation } from '@protector/entities/static-point/models';
import type { StaticPointsDateRange } from './static-points.models';

export const StaticPointsActionsTypes = {
  LOAD_STATIC_POINTS: '[Static Point] Load Static Points',
  LOAD_STATIC_POINTS_SUCCESS: '[Static Point] Load Static Points Success',
  LOAD_STATIC_POINTS_FAILURE: '[Static Point] Load Static Points Failure',
  LOAD_STATIC_POINTS_TEMPLATES: '[Static Point] Load Static Points Templates',
  LOAD_STATIC_POINTS_TEMPLATES_SUCCESS: '[Static Point] Load Static Points Templates Success',
  LOAD_STATIC_POINTS_TEMPLATES_FAILURE: '[Static Point] Load Static Points Templates Failure',
  CLEAR_STATIC_POINTS_TEMPLATES: '[Static Point] Clear Static Points Templates',
  CREATE_STATIC_POINT: '[Static Point] Create Static Point',
  DELETE_STATIC_POINT: '[Static Point] Delete Static Point'
} as const;

export const LoadStaticPoints = (propertyId: UUID, fields: StaticPointFieldEnum[] = [StaticPointFieldEnum.ALL]) => {
  return {
    type: StaticPointsActionsTypes.LOAD_STATIC_POINTS,
    payload: { propertyId, fields }
  };
};

export const LoadStaticPointsSuccess = (staticPoints: StaticPoint[]) => {
  return {
    type: StaticPointsActionsTypes.LOAD_STATIC_POINTS_SUCCESS,
    payload: staticPoints
  };
};

export const LoadStaticPointsFailure = (error: string) => {
  return {
    type: StaticPointsActionsTypes.LOAD_STATIC_POINTS_FAILURE,
    payload: error
  };
};

export const LoadStaticPointsTemplates = (propertyId: UUID, dateRange?: StaticPointsDateRange) => {
  return {
    type: StaticPointsActionsTypes.LOAD_STATIC_POINTS_TEMPLATES,
    payload: { propertyId, dateRange }
  };
};

export const LoadStaticPointsTemplatesSuccess = (templates: StaticPoint[]) => {
  return {
    type: StaticPointsActionsTypes.LOAD_STATIC_POINTS_TEMPLATES_SUCCESS,
    payload: templates
  };
};

export const LoadStaticPointsTemplatesFailure = (error: string) => {
  return {
    type: StaticPointsActionsTypes.LOAD_STATIC_POINTS_TEMPLATES_FAILURE,
    payload: error
  };
};

export const ClearStaticPointsTemplates = () => {
  return {
    type: StaticPointsActionsTypes.CLEAR_STATIC_POINTS_TEMPLATES
  };
};

export const CreateStaticPoint = (type: StaticPointType, staticPoint: StaticPointCreation, callback: UpsertStationSuccessCallbacks) => {
  return {
    type: StaticPointsActionsTypes.CREATE_STATIC_POINT,
    payload: { type, staticPoint, callback }
  };
};
